import React from 'react'


const Spacer = ({pixels}) => (
  <div style={{
    height: pixels,
    overflow: 'hidden',
  }}>
    &nbsp;
  </div>
)
export default Spacer